import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.views.QuoteView.';
  // Dialog Buttons
  public static readonly discardChanges = `${Id.prefix}discardChanges`;
  public static readonly save = `${Id.prefix}save`;
  public static readonly cancel = `${Id.prefix}cancel`;
  // Page Titles
  public static readonly information = `${Id.prefix}information`;
  public static readonly defaults = `${Id.prefix}defaults`;
  public static readonly quoteItemPlural = `${Id.prefix}quoteItemPlural`;
  public static readonly quoteIguPlural = `${Id.prefix}quoteIguPlural`;
  // Actions
  public static readonly refreshList = `${Id.prefix}refreshList`;
  public static readonly validate = `${Id.prefix}validate`;
  public static readonly addFrame = `${Id.prefix}addFrame`;
  public static readonly addFreehand = `${Id.prefix}addFreehand`;
  public static readonly requestSpecialItem = `${Id.prefix}requestSpecialItem`;
  public static readonly approve = `${Id.prefix}approve`;
  public static readonly accept = `${Id.prefix}accept`;
  public static readonly reject = `${Id.prefix}reject`;
  public static readonly issue = `${Id.prefix}issue`;
  public static readonly makeQuoteActive = `${Id.prefix}makeQuoteActive`;
  public static readonly editRevision = `${Id.prefix}editRevision`;
  public static readonly completeRevision = `${Id.prefix}completeRevision`;
  public static readonly shopDrawingPlural = `${Id.prefix}shopDrawingPlural`;
  public static readonly pushSupplierQuoteToV6 = `${Id.prefix}pushSupplierQuoteToV6`;
  // Status/menus
  public static readonly reports = `${Id.prefix}reports`;
  public static readonly supplier = `${Id.prefix}supplier`;
  public static readonly status = `${Id.prefix}status`;
  // Toasts/messages
  public static readonly quoteItemRefreshed = `${Id.prefix}quoteItemRefreshed`;
  public static readonly closeAllQuoteItemPagesBeforeRefresh = `${Id.prefix}closeAllQuoteItemPagesBeforeRefresh`;
  public static readonly closeAndSaveExistingFrameOrSpecialItemEditor = `${Id.prefix}closeAndSaveExistingFrameOrSpecialItemEditor`;
  public static readonly quoteItemDeleted = `${Id.prefix}quoteItemDeleted`;
  public static readonly unableToDeleteSelectedQuoteItem = `${Id.prefix}unableToDeleteSelectedQuoteItem`;
  public static readonly saveAndCloseQuoteItemBeforeEditingProperties = `${Id.prefix}saveAndCloseQuoteItemBeforeEditingProperties`;
  public static readonly closeAllQuoteItemBeforeEditingQuoteIgu = `${Id.prefix}closeAllQuoteItemBeforeEditingQuoteIgu`;
  public static readonly initializingQuoteData = `${Id.prefix}initializingQuoteData`;
  public static readonly invalidQuoteItem = `${Id.prefix}invalidQuoteItem`;
  // Validation
  public static readonly issuedQuoteRevalidation = `${Id.prefix}issuedQuoteRevalidation`;
  public static readonly activeQuoteValidation = `${Id.prefix}activeQuoteValidation`;
  public static readonly unsupportedAction = `${Id.prefix}unsupportedAction`;
  public static readonly cannotEditQuoteItem = `${Id.prefix}cannotEditQuoteItem`;
  public static readonly discardSupplierPriceAdjustmentOnEdit = `${Id.prefix}discardSupplierPriceAdjustmentOnEdit`;
  public static readonly supplierPriceAdjustment = `${Id.prefix}supplierPriceAdjustment`;
  public static readonly notFinalDrawingContinue = `${Id.prefix}notFinalDrawingContinue`;
  public static readonly shopdrawingsRevalidationRequired = `${Id.prefix}shopdrawingsRevalidationRequired`;
  public static readonly validationRequired = `${Id.prefix}validationRequired`;
  public static readonly emailedLinkWhenReady = `${Id.prefix}emailedLinkWhenReady`;
  public static readonly supplierquoteRevalidationRequired = `${Id.prefix}supplierquoteRevalidationRequired`;
  public static readonly createV6QuoteInSupplierSystem = `${Id.prefix}createV6QuoteInSupplierSystem`;
  public static readonly showVrmlModel = `${Id.prefix}showVrmlModel`;
}

export class LangQuoteView {
  private constructor() {}
  public static discardChanges(): string {
    return interpolate(Id.discardChanges);
  }
  public static save(): string {
    return interpolate(Id.save);
  }
  public static cancel(): string {
    return interpolate(Id.cancel);
  }
  public static information(): string {
    return interpolate(Id.information);
  }
  public static defaults(): string {
    return interpolate(Id.defaults);
  }
  public static quoteItemPlural(): string {
    return interpolate(Id.quoteItemPlural);
  }
  public static quoteIguPlural(): string {
    return interpolate(Id.quoteIguPlural);
  }
  public static refreshList(): string {
    return interpolate(Id.refreshList);
  }
  public static validate(): string {
    return interpolate(Id.validate);
  }
  public static addFrame(): string {
    return interpolate(Id.addFrame);
  }
  public static addFreehand(): string {
    return interpolate(Id.addFreehand);
  }
  public static requestSpecialItem(): string {
    return interpolate(Id.requestSpecialItem);
  }
  public static approve(): string {
    return interpolate(Id.approve);
  }
  public static accept(): string {
    return interpolate(Id.accept);
  }
  public static reject(): string {
    return interpolate(Id.reject);
  }
  public static issue(): string {
    return interpolate(Id.issue);
  }
  public static makeQuoteActive(): string {
    return interpolate(Id.makeQuoteActive);
  }
  public static editRevision(): string {
    return interpolate(Id.editRevision);
  }
  public static completeRevision(): string {
    return interpolate(Id.completeRevision);
  }
  public static shopDrawingPlural(): string {
    return interpolate(Id.shopDrawingPlural);
  }
  public static pushSupplierQuoteToV6(): string {
    return interpolate(Id.pushSupplierQuoteToV6);
  }
  public static reports(): string {
    return interpolate(Id.reports);
  }
  public static supplier(): string {
    return interpolate(Id.supplier);
  }
  public static status(): string {
    return interpolate(Id.status);
  }
  public static quoteItemRefreshed(): string {
    return interpolate(Id.quoteItemRefreshed);
  }
  public static closeAllQuoteItemPagesBeforeRefresh(): string {
    return interpolate(Id.closeAllQuoteItemPagesBeforeRefresh);
  }
  public static closeAndSaveExistingFrameOrSpecialItemEditor(): string {
    return interpolate(Id.closeAndSaveExistingFrameOrSpecialItemEditor);
  }
  public static quoteItemDeleted(): string {
    return interpolate(Id.quoteItemDeleted);
  }
  public static unableToDeleteSelectedQuoteItem(): string {
    return interpolate(Id.unableToDeleteSelectedQuoteItem);
  }
  public static saveAndCloseQuoteItemBeforeEditingProperties(): string {
    return interpolate(Id.saveAndCloseQuoteItemBeforeEditingProperties);
  }
  public static closeAllQuoteItemBeforeEditingQuoteIgu(): string {
    return interpolate(Id.closeAllQuoteItemBeforeEditingQuoteIgu);
  }
  public static initializingQuoteData(): string {
    return interpolate(Id.initializingQuoteData);
  }
  public static invalidQuoteItem(): string {
    return interpolate(Id.invalidQuoteItem);
  }
  public static issuedQuoteRevalidation(params: { supplierName: string }): string {
    return interpolate(Id.issuedQuoteRevalidation, params);
  }
  public static activeQuoteValidation(params: { supplierName: string }): string {
    return interpolate(Id.activeQuoteValidation, params);
  }
  public static unsupportedAction(params: { action: string }): string {
    return interpolate(Id.unsupportedAction, params);
  }
  public static cannotEditQuoteItem(): string {
    return interpolate(Id.cannotEditQuoteItem);
  }
  public static discardSupplierPriceAdjustmentOnEdit(): string {
    return interpolate(Id.discardSupplierPriceAdjustmentOnEdit);
  }
  public static supplierPriceAdjustment(): string {
    return interpolate(Id.supplierPriceAdjustment);
  }
  public static notFinalDrawingContinue(): string {
    return interpolate(Id.notFinalDrawingContinue);
  }
  public static shopdrawingsRevalidationRequired(): string {
    return interpolate(Id.shopdrawingsRevalidationRequired);
  }
  public static validationRequired(): string {
    return interpolate(Id.validationRequired);
  }
  public static emailedLinkWhenReady(): string {
    return interpolate(Id.emailedLinkWhenReady);
  }
  public static supplierquoteRevalidationRequired(): string {
    return interpolate(Id.supplierquoteRevalidationRequired);
  }
  public static createV6QuoteInSupplierSystem(): string {
    return interpolate(Id.createV6QuoteInSupplierSystem);
  }
  public static showVrmlModel(): string {
    return interpolate(Id.showVrmlModel);
  }
}

export class QuoteViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // Dialog Buttons
    register.add(Id.discardChanges, 'Discard Changes', 'Button label for discarding changes');
    register.add(Id.save, 'Save', 'Button label for saving');
    register.add(Id.cancel, 'Cancel', 'Button label for cancel');
    // Page Titles
    register.add(Id.information, 'Information', 'Tab title for information');
    register.add(Id.defaults, 'Defaults', 'Tab title for defaults');
    register.add(Id.quoteItemPlural, "{{glossary 'quote-item:plural'}}", 'Tab title for quote items');
    register.add(Id.quoteIguPlural, "{{glossary 'quote-igu:plural'}}", 'Tab title for quote IGUs');
    // Actions
    register.add(Id.refreshList, 'Refresh List', 'Button label for refreshing list');
    register.add(Id.validate, 'Validate', 'Button label for validate');
    register.add(Id.addFrame, "Add {{glossary 'frame'}}", 'Button label for adding a frame');
    register.add(Id.addFreehand, "Add {{glossary 'freehand'}}", 'Button label for adding freehand');
    register.add(
      Id.requestSpecialItem,
      "Request {{glossary 'special-item'}}",
      'Button label for requesting special item'
    );
    register.add(Id.approve, 'Approve', 'Button label for approve');
    register.add(Id.accept, 'Accept', 'Button label for accept');
    register.add(Id.reject, 'Reject', 'Button label for reject');
    register.add(Id.issue, 'Issue', 'Button label for issue');
    register.add(Id.makeQuoteActive, "Make {{glossary 'quote'}} Active", 'Button label for making quote active');
    register.add(Id.editRevision, 'Edit Revision', 'Button label for edit revision');
    register.add(Id.completeRevision, 'Complete Revision', 'Button label for complete revision');
    register.add(Id.shopDrawingPlural, "{{glossary 'shopdrawing:plural'}}", 'Button label for shop drawings');
    register.add(
      Id.pushSupplierQuoteToV6,
      "DIAGNOSTIC TOOL: Push {{glossary 'supplier'}} {{glossary 'quote'}} to V6",
      'Button label for pushing supplier quote to V6'
    );
    // Status/menus
    register.add(Id.reports, 'Reports', 'Menu label for reports');
    register.add(Id.supplier, "{{glossary 'supplier'}}", 'Menu label for supplier');
    register.add(Id.status, 'Status', 'Menu label for status');
    // Toasts/messages
    register.add(
      Id.quoteItemRefreshed,
      "{{glossary 'quote-item:plural'}} refreshed",
      'Toast for quote items refreshed'
    );
    register.add(
      Id.closeAllQuoteItemPagesBeforeRefresh,
      "Please close all open {{glossary 'quote-item:plural'}} pages before refreshing this page",
      'Toast for closing all quote item pages before refresh'
    );
    register.add(
      Id.closeAndSaveExistingFrameOrSpecialItemEditor,
      "Please close and save the existing {{glossary 'frame'}}/{{glossary 'special-item'}} editor before opening another one",
      'Toast for closing and saving existing frame or special item editor'
    );
    register.add(Id.quoteItemDeleted, "{{glossary 'quote-item'}} has been deleted", 'Toast for quote item deleted');
    register.add(
      Id.unableToDeleteSelectedQuoteItem,
      "Unable to delete the selected {{glossary 'quote-item'}}",
      'Toast for unable to delete quote item'
    );
    register.add(
      Id.saveAndCloseQuoteItemBeforeEditingProperties,
      "Please save and close the {{glossary 'quote-item'}} before editing its properties",
      'Toast for saving and closing quote item before editing properties'
    );
    register.add(
      Id.closeAllQuoteItemBeforeEditingQuoteIgu,
      "please close all {{glossary 'quote-item:plural'}} before editing {{glossary 'quote-igu:plural'}}",
      'Toast for closing all quote items before editing quote IGU'
    );
    register.add(
      Id.initializingQuoteData,
      "Initializing {{glossary 'quote'}} data",
      'Message for initializing quote data'
    );
    register.add(Id.invalidQuoteItem, "Invalid {{glossary 'quote-item'}}", 'Message for invalid quote item');
    // Validation
    register.add(
      Id.issuedQuoteRevalidation,
      `This {{glossary 'quote'}} is out of date due to an update by {{glossary 'supplier'}} **{{supplierName}}**<br>
Please attempt to revalidate using the "Validate" button.<br>
If the {{glossary 'quote'}} can be revalidated, then all prices will remain as they are, even if the {{glossary 'supplier'}} prices have been updated. <br>
If the {{glossary 'quote'}} cannot be revalidated, then it must be cancelled and you must start a new {{glossary 'quote'}}`,
      'Markdown message for issued quote revalidation'
    );
    register.add(
      Id.activeQuoteValidation,
      `This {{glossary 'quote'}} is out of date due to an update by {{glossary 'supplier'}} **{{supplierName}}**<br>
Please attempt to revalidate using the "Validate" button.<br>
After validation, please review the {{glossary 'quote-item:plural'}} carefully for any unexpected price or design changes`,
      'Markdown message for active quote validation'
    );
    register.add(Id.unsupportedAction, '{{action}} is not supported yet', 'Message for unsupported quote item action');
    register.add(
      Id.cannotEditQuoteItem,
      "This {{glossary 'quote-item'}} cannot be edited",
      'Message for non-editable quote item'
    );
    register.add(
      Id.discardSupplierPriceAdjustmentOnEdit,
      'If you make changes that affect the price on this item the supplier price adjustment will be discarded. You will then need to reactivate the associated support ticket to request a supplier review.',
      'Warning for discarding supplier price adjustment on edit'
    );
    register.add(Id.supplierPriceAdjustment, 'Supplier Price Adjustment', 'Dialog title for supplier price adjustment');
    register.add(
      Id.notFinalDrawingContinue,
      'This is not a final Drawing. Continue?',
      'Confirmation for non-final drawing'
    );
    register.add(
      Id.shopdrawingsRevalidationRequired,
      "Shop drawings cannot be produced until revalidation of the {{glossary 'quote'}} is performed",
      'Message for shop drawings revalidation required'
    );
    register.add(Id.validationRequired, 'Validation required', 'Dialog title for validation required');
    register.add(
      Id.emailedLinkWhenReady,
      'You will be emailed a link to the document when it is ready',
      'Info for emailed link'
    );
    register.add(
      Id.supplierquoteRevalidationRequired,
      "V6 Quote cannot be produced until revalidation of the {{glossary 'quote'}} is performed",
      'Message for supplier quote revalidation required'
    );
    register.add(
      Id.createV6QuoteInSupplierSystem,
      `This will create a V6 quote in the supplier system.
      This is for DEBUG PURPOSE ONLY.
      It is not linked to this {{glossary 'quote'}} and will be created using the current quote configuration including any warnings and errors. Continue?`,
      'Confirmation for creating V6 quote in supplier system'
    );
    register.add(Id.showVrmlModel, 'View 3D Model', 'Button caption for viewing 3D VRML model');
  }
}
